import React, { memo } from "react";

import Button from "app/components/Button/Button";
import { FirmwareDTO } from "@generated/v2";
import Row from "app/components/Common/Row";
import Icon from "app/components/Icon/Icon";

import styles from "./ReaderFirmwareDownloadButton.module.scss";
import { Tooltip } from "antd";

type IProps = Pick<FirmwareDTO, "url" | "errorMessage">;

function ReaderFirmwareDownloadButton({
  url,
  errorMessage,
}: IProps): React.ReactElement {
  return (
    <Row>
      {!!url ? <Button type="link" href={url} icon="download" /> : null}
      {!!errorMessage ? (
        <Tooltip title={errorMessage}>
          <Icon type="warning" theme="outlined" className={styles.error} />
        </Tooltip>
      ) : null}
    </Row>
  );
}

export default memo(ReaderFirmwareDownloadButton);
